import { onboardingProgress, TRAINING_ROUTES, } from "@repo/contract/training";
import { getJson, } from "../core/request";
import { profileKeys } from "./keys";
/**
 * `GET /me/onboarding` — how far through Session 1 this person is (`D113`).
 *
 * Read-only: the answers are written through the section `PUT`s and the
 * weight through `POST /me/measurements`, and every one of those invalidates
 * this key (`profileWriteInvalidates`), so the stepper re-reads `next` after
 * each answer without naming this query.
 */
export function fetchOnboardingProgress(api, init) {
    return getJson(api, TRAINING_ROUTES.onboarding, onboardingProgress, init);
}
export function onboardingProgressOptions(api) {
    return {
        queryFn: ({ signal }) => fetchOnboardingProgress(api, { signal }),
        queryKey: profileKeys.onboarding,
    };
}
//# sourceMappingURL=onboarding.js.map